import React, { useCallback } from "react"
import { signInWithRedirect } from "aws-amplify/auth"
import { Button } from "@aws-amplify/ui-react"

type Props = {
  setError: React.Dispatch<React.SetStateAction<string | null>>
}

export default function GoogleSignInButton({ setError }: Props) {
  const handleSignIn = useCallback(async () => {
    try {
      await signInWithRedirect({ provider: "Google" })
    } catch (err) {
      console.error("Google sign-in failed", err)
      setError("Sign-in failed")
    }
  }, [setError])

  return (
    <Button onClick={handleSignIn} variation="primary" data-testid="google-signin">
      Sign in with Google
    </Button>
  )
}
